import { handleResponse, handleError } from "./apiUtils";
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';


/**
 *
 * @param {*} code
 */
export const getAuth = async (code) => {
  const claim = await API.graphql(graphqlOperation(queries.authApIgetClaim, { code }));
  return claim.data.authAPIgetClaim;
}


/**
 *
 * @param {*} sso
 */
export const getUserSession = async (sso) => {
  console.log(`getUserSession called w/ sso: ${sso}`);
  const userSession = await API.graphql(graphqlOperation(queries.userApIgetSession, { sso }));
  return userSession.data.userAPIgetSession;
}


export const getUpdatingUser = async (userId) => {

  let response = await API.graphql(graphqlOperation(queries.userApIgetUpdatingUser, { userId }))
    .catch(handleError);

  return response.data.userAPIgetUpdatingUser;
}

export const updateUserHistory = async (resourceId, userId) => {

  let response = await API.graphql(graphqlOperation(mutations.userApIupdateUserHistory, { resourceId, userId }))
    .catch(handleError);

  return response.data.userAPIupdateUserHistory;
}

export const getBranch = async (userId) => {

  let response = await API.graphql(graphqlOperation(queries.userApIgetBranch, { userId }))
    .catch(handleError);

  return response.data.userAPIgetBranch;
}



// WEBPACK FOOTER //
// ./src/api/userApi.js